import React from 'react';
import { createRoot } from 'react-dom/client'; // Cambia a createRoot
import App from './App';
import './styles.css';

const container = document.getElementById('root');
const root = createRoot(container); // Crea un root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);